<template>
  <div>
    <div class="bg-color-w py-20 px-30 ">
      <el-row class="">
        <div class="float-l">
          <div class="float-l">{{ $t("xmsq.xsnr") }}：</div>
          <div class="float-l">
            <el-button
              type="primary"
              size="mini"
              :icon="active == '1' ? 'el-icon-check' : 'el-icon-aim'"
              :plain="active == '1' ? false : true"
              @click="setActiveBtn('1')"
            >
              {{ $t("xmsq.sqxxsyqk") }}
            </el-button>
            <el-button
              type="primary"
              size="mini"
              :icon="active == '2' ? 'el-icon-check' : 'el-icon-aim'"
              :plain="active == '2' ? false : true"
              @click="setActiveBtn('2')"
            >
              {{ $t("xmsq.bsqxxsyqk") }}
            </el-button>
          </div>
        </div>
      </el-row>
      <div class="dy-flex">
        <div class="mt-20 mr-20 wt-p-25">
          <el-input
            :placeholder="$t('xmsq.searchPlaceholder')"
            v-model="filterText"
          >
          </el-input>
          <el-tree
            class="overf-a"
            :data="treeData"
            :props="defaultProps"
            default-expand-all
            @node-click="handleNodeClick"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            ref="tree"
            :style="treeStyle"
          >
            <template #default="{ node }">
              <el-tooltip
                class="item"
                effect="light"
                :content="node.label"
                placement="right-start"
                :open-delay="250"
              >
                <span class="custom-tree-node">
                  <span :class="node.id === treeSel ? 'color-primary' : ''">{{
                    node.label
                  }}</span>
                </span>
              </el-tooltip>
            </template></el-tree
          >
        </div>
        <div v-if="sqxxyl" class="wt-p-75">
          <div class="mt-20">
            <!-- 动态表格组件 -->
            <TableCommon
              v-loading="tabLoading"
              :element-loading-text="$t('elTable.loadingText')"
              element-loading-spinner="el-icon-loading"
              :tableColumns="tableColumns"
              :tableData="tableData"
              :currentPage="currentPage"
              :limit="limit"
              :uniqueNum="uniqueNum"
              :cellStyle="$store.state.cellStyle"
              :headerCellStyle="$store.state.headerCellStyle"
              :height="$store.state.screenHeight - 260"
              :width="100"
            ></TableCommon>
          </div>
          <div>
            <!-- 分页组件 -->
            <Pagination
              :currentPage="currentPage"
              :total="total"
              :limit="limit"
              :small="true"
              :pageSizes="$store.state.pageSizes"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
              :uniqueNum="uniqueNum"
            />
          </div>
        </div>
        <div v-else class="wt-p-75">
          <div class="mt-20">
            <div
              v-if="xtSelect === '1002'"
              class="text-a-c my-10 fs-20 fw-bold"
            >
              {{ $t("xmsq.sbxtsqxmsymx") }}
            </div>
            <div v-else class="text-a-c my-10 fs-20 fw-bold">
              {{ $t("xmsq.bxxtsqxmsymx") }}
            </div>
            <div class="my-5">
              {{ $t("common.system") }}：<el-select
                v-model="xtSelect"
                size="mini"
                @change="getSyxxByBsqr()"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <p class="mt-20">{{ $t("sqsq.sqje") }}:</p>
              <div class="mt-5">
                <el-table
                  :data="sqjeData"
                  max-height="250"
                  border
                  style="width: 100%"
                  :header-cell-style="$store.state.headerCellStyle"
                  :cell-style="$store.state.cellStyle"
                  v-loading="selectLoading"
                  :element-loading-text="$t('elTable.loadingText')"
                  element-loading-spinner="el-icon-loading"
                >
                  <el-table-column
                    prop="nian"
                    :label="$t('xmsq.qsrq')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="yue"
                    :label="$t('xmsq.jzrq')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="lsh"
                    :label="$t('xmsq.lsh')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="lrrq"
                    :label="$t('xmsq.lrrq')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="zy"
                    :label="$t('xmsq.zy')"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="zje"
                    :label="$t('xmsq.zje')"
                    width="180"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ moneyFormatter(scope.row["zje"]) }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <p class="mt-20">{{ $t("xmsq.symx") }}:</p>
              <div class="mt-5">
                <el-table
                  :data="symxData"
                  max-height="250"
                  border
                  style="width: 100%"
                  :header-cell-style="$store.state.headerCellStyle"
                  :cell-style="$store.state.cellStyle"
                  v-loading="selectLoading"
                  :element-loading-text="$t('elTable.loadingText')"
                >
                  <el-table-column
                    prop="nian"
                    :label="$t('xmsq.year')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="yue"
                    :label="$t('xmsq.month')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="lsh"
                    :label="$t('xmsq.lsh')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="lrrq"
                    :label="$t('xmsq.lrrq')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="zy"
                    :label="$t('xmsq.zy')"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="zje"
                    :label="$t('xmsq.zje')"
                    width="180"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ moneyFormatter(scope.row["zje"]) }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <p class="mt-20">{{ $t("xmsq.syje") }}:</p>
              <div class="mt-5">
                <el-table
                  :data="syjeData"
                  max-height="250"
                  border
                  style="width: 100%"
                  :header-cell-style="$store.state.headerCellStyle"
                  :cell-style="$store.state.cellStyle"
                  v-loading="selectLoading"
                  :element-loading-text="$t('elTable.loadingText')"
                >
                  <el-table-column
                    prop="nian"
                    :label="$t('xmsq.year')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="yue"
                    :label="$t('xmsq.month')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="lsh"
                    :label="$t('xmsq.lsh')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="lrrq"
                    :label="$t('xmsq.lrrq')"
                    width="180"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="zy"
                    :label="$t('xmsq.zy')"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="zje"
                    :label="$t('xmsq.zje')"
                    width="180"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ moneyFormatter(scope.row["zje"]) }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as sqgl from "@/api/sqglSpecial";

export default {
  //   项目授权信息及使用信息一览
  name: "projectAuzUseView",
  computed: {
    treeStyle() {
      return {
        height: this.$store.state.screenHeight - 270 + "px",
        width: "100%",
      };
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      treeData: [],
      filterText: "",
      tabLoading: true,
      currentPage: 1,
      limit: this.$store.state.dataDisplayNum,
      total: 0, // 数据量
      tableColumns: [],
      tableData: [],
      uniqueNum: "Y120105-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      yhxx: this.$store.state.yhxx.yhxx,
      bsqr: "",
      flg: "0",
      saveflg: "0",
      ryxx: null,
      ryxxData: [],
      rydm: null,
      dialogbsqr: false,
      multipleChoice: [],
      checkList: [],
      show: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      sqxxyl: true,
      options: [
        {
          value: "1002",
          label: this.$t("xmsq.srsb"),
        },
        {
          value: "1003",
          label: this.$t("xmsq.wsbx"),
        },
      ],
      xtSelect: "1002",
      sqjeData: [],
      symxData: [],
      syjeData: [],
      selectLoading: true,
      selectParam: {},
      bmbh: "",
      xmbh: "",
      treeSel: "全部",
      active: "1",
    };
  },
  methods: {
    // 设置显示授权项目或被授权项目
    setActiveBtn(active) {
      if (active == "1") {
        this.getBmXmTreeData();
      } else if (active == "2") {
        this.getBmXmTreeDataByBsqr();
      }
      this.active = active;
      this.toSqxxOrBsqxx(this.bmbh, this.xmbh);
    },
    toSqxxOrBsqxx(bmbh, xmbh) {
      if (this.active == "1") {
        this.getSqxx(bmbh, xmbh);
      } else if (this.active == "2") {
        this.getBsqxx(bmbh, xmbh);
      }
    },
    //   项目授权信息及使用信息一览
    getSqxx(bmbh, xmbh) {
      this.bmbh = bmbh;
      this.xmbh = xmbh;
      let params = {};
      params.yhbh = this.yhxx.ygbh;
      params.bmbh = bmbh;
      params.xmbh = xmbh;
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      this.tabLoading = true;
      sqgl.getSqxx(params).then((res) => {
        this.tabLoading = false;
        this.tableData = res.data.data;
        for (let i = 0; i < this.tableData.length; i++) {
          let params2 = {};
          params2.bmbh = this.tableData[i].bmbh;
          params2.xmbh = this.tableData[i].xmbh;
          params2.bsqrzjh = this.tableData[i].bsqrzjh;
          if (this.tableData[i].sysid === "1002") {
            if (this.action == "1") {
              sqgl.getXmSyxxSb(params2).then((res) => {
                this.tableData[i].yhfje = res.data.data.yhfje;
                this.tableData[i].syje = res.data.data.syje;
              });
            } else {
              sqgl.getXmbsyxxSb(params2).then((res) => {
                this.tableData[i].yhfje = res.data.data.yhfje;
                this.tableData[i].syje = res.data.data.syje;
              });
            }
          } else if (this.tableData[i].sysid === "1003") {
            if (this.action == "1") {
              sqgl.getXmSyxxBx(params2).then((res) => {
                this.tableData[i].yhfje = res.data.data.yhfje;
                this.tableData[i].syje = res.data.data.syje;
              });
            } else {
              sqgl.getXmbsyxxBx(params2).then((res) => {
                this.tableData[i].yhfje = res.data.data.yhfje;
                this.tableData[i].syje = res.data.data.syje;
              });
            }
          }
        }
        if (this.tableData.length > 0) {
          this.total = this.tableData[0].count;
        }
      });
    },
    getBmXmTreeData() {
      let params = {};
      params.yhbh = this.yhxx.ygbh;
      sqgl.getBmXmTreeData(params).then((res) => {
        this.treeData = [res.data.data];
      });
    },
    getBsqxx(bmbh, xmbh) {
      this.bmbh = bmbh;
      this.xmbh = xmbh;
      let params = {};
      params.yhbh = this.yhxx.ygbh;
      params.bmbh = bmbh;
      params.xmbh = xmbh;
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      this.tabLoading = true;
      sqgl.getBsqxx(params).then((res) => {
        this.tabLoading = false;
        this.tableData = res.data.data;
        for (let i = 0; i < this.tableData.length; i++) {
          let params2 = {};
          params2.bmbh = this.tableData[i].bmbh;
          params2.xmbh = this.tableData[i].xmbh;
          params2.bsqrzjh = this.tableData[i].bsqrzjh;
        }
        if (this.tableData.length > 0) {
          this.total = this.tableData[0].count;
        }
      });
    },
    getBmXmTreeDataByBsqr() {
      let params = {};
      params.yhbh = this.yhxx.ygbh;
      sqgl.getBmXmTreeDataByBsqr(params).then((res) => {
        this.treeData = [res.data.data];
      });
    },
    handleNodeClick(data, node, event) {
      this.treeSel = node.id;
      let bmbh = null;
      let xmbh = null;
      let bsqrzjh = null;
      this.currentPage = 1;
      switch (data.level) {
        case 0:
          this.sqxxyl = true;
          this.toSqxxOrBsqxx(bmbh, xmbh);
          break;
        case 1:
          this.sqxxyl = true;
          bmbh = data.value;
          this.toSqxxOrBsqxx(bmbh, xmbh);
          break;
        case 2:
          this.sqxxyl = true;
          bmbh = node.parent.data.value;
          xmbh = data.value;
          this.toSqxxOrBsqxx(bmbh, xmbh);
          break;
        case 3:
          this.sqxxyl = false;
          this.selectParam.bmbh = node.parent.parent.data.value;
          this.selectParam.xmbh = node.parent.data.value;
          this.selectParam.bsqrzjh = data.value;
          this.getSyxxByBsqr();
          break;
      }
    },
    getSbSyxxByBsqr() {
      sqgl
        .getSbSyxxByBsqr(this.selectParam)
        .then((res) => {
          this.selectLoading = false;
          let data = res.data.data;
          data.forEach((item) => {
            switch (item.flag) {
              case "1":
                this.sqjeData.push(item);
                break;
              case "2":
                this.symxData.push(item);
                break;
              case "3":
                this.syjeData.push(item);
                break;
            }
          });
        })
        .catch((e) => {
          this.selectLoading = false;
        });
    },
    getBxSyxxByBsqr() {
      sqgl
        .getBxSyxxByBsqr(this.selectParam)
        .then((res) => {
          this.selectLoading = false;
          let data = res.data.data;
          data.forEach((item) => {
            switch (item.flag) {
              case "1":
                this.sqjeData.push(item);
                break;
              case "2":
                this.symxData.push(item);
                break;
              case "3":
                this.syjeData.push(item);
                break;
            }
          });
        })
        .catch((e) => {
          this.selectLoading = false;
        });
    },
    getSbSyxxBySqr() {
      sqgl
        .getSbSyxxBySqr(this.selectParam)
        .then((res) => {
          this.selectLoading = false;
          let data = res.data.data;
          data.forEach((item) => {
            switch (item.flag) {
              case "1":
                this.sqjeData.push(item);
                break;
              case "2":
                this.symxData.push(item);
                break;
              case "3":
                this.syjeData.push(item);
                break;
            }
          });
        })
        .catch((e) => {
          this.selectLoading = false;
        });
    },
    getBxSyxxBySqr() {
      sqgl
        .getBxSyxxBySqr(this.selectParam)
        .then((res) => {
          this.selectLoading = false;
          let data = res.data.data;
          data.forEach((item) => {
            switch (item.flag) {
              case "1":
                this.sqjeData.push(item);
                break;
              case "2":
                this.symxData.push(item);
                break;
              case "3":
                this.syjeData.push(item);
                break;
            }
          });
        })
        .catch((e) => {
          this.selectLoading = false;
        });
    },
    getSyxxByBsqr(val) {
      this.sqjeData = [];
      this.symxData = [];
      this.syjeData = [];
      this.selectLoading = true;
      if (this.xtSelect === "1002") {
        if (this.active == "1") {
          this.getSbSyxxByBsqr();
        } else {
          this.getSbSyxxBySqr();
        }
      } else {
        if (this.active == "1") {
          this.getBxSyxxByBsqr();
        } else {
          this.getBxSyxxBySqr();
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.toSqxxOrBsqxx(this.bmbh, this.xmbh);
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.toSqxxOrBsqxx(this.bmbh, this.xmbh);
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y120105";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
    },
    // 查询项目人员
    handleIconClick() {
      let arr = [];
      if (this.bsqr != null && this.bsqr != "") {
        yhxx.getSysUser({ rydm: this.bsqr }).then((res) => {
          let res1 = res.data.data;
          arr = res1.ryxx;
          this.saveflg = res1.flg;
          switch (res1.ryxx.length) {
            case 0:
              break;
            case 1:
              this.flg = res1.flg;
              this.ryxx = arr[0];
              if (this.flg == "1") {
                this.bsqr = arr[0].xm;
              } else {
                this.bsqr = arr[0].rydm;
              }
              this.rydm = arr[0].rydm;
              this.toSqxxOrBsqxx(this.bmbh, this.xmbh);
              break;
            default:
              this.dialogbsqr = true;
              this.ryxxData = res1.ryxx;
              break;
          }
        });
      } else {
        this.flg = "0";
        this.rydm = null;
        this.toSqxxOrBsqxx(this.bmbh, this.xmbh);
      }
    },
    // 格式化金额方法
    moneyFormatter(value) {
      return this.$comUtils.moneyFormat(value);
    },
  },
  mounted() {
    this.toSqxxOrBsqxx();
    this.getPageTableConfig();
    this.getBmXmTreeData();
  },
};
</script>

<style lang="scss">
.custom-tree-node {
  overflow: hidden;
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
</style>
